const baseUrl = '/api/v1/banners';

export const retrieveBanners = (page = 'welcome') => {
  const uri = `${baseUrl}?page=${encodeURIComponent(page)}`;

  return fetch(uri).then((res) => res.json());
};

export const findActiveBanners = async (page = 'welcome') => {
  let data;
  try {
    data = await retrieveBanners(page);
  } catch (e) {
    console.error('Failed to fetch active banners', e);
    return null;
  }

  // Do not return data or cache it, if nothing is there
  if (Object.keys(data).length < 1 || !data.desktop) {
    return null;
  }

  return data;
};
